import { render, staticRenderFns } from "./Template3.vue?vue&type=template&id=2ca8e361&scoped=true&"
import script from "./Template3.vue?vue&type=script&lang=js&"
export * from "./Template3.vue?vue&type=script&lang=js&"
import style0 from "./Template3.vue?vue&type=style&index=0&id=2ca8e361&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca8e361",
  null
  
)

export default component.exports